
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')
window.Vue = require('vue')

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueRouter from 'vue-router'
window.Vue.use(VueRouter)

import VueTelInput from 'vue-tel-input'
Vue.use(VueTelInput)

import VuePapaParse from 'vue-papa-parse'
Vue.use(VuePapaParse)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.moment = require('moment')

// イベントバス
window.bus = new Vue()

/** ==========================================================================
 * 会員 関連コンポーネント
 * ========================================================================== */
// ナビゲーションバー
Vue.component('nav-bar', require('./components/user/NavBar').default)

// ディープリンクのハンドリング
Vue.component('user-deeplink-handle', require('./components/user/UserDeeplinkHandle').default)

// 診療画面
Vue.component('user-consultation', require('./components/user/UserConsultation').default)
Vue.component('user-video-stream-agora', require('./components/user/UserVideoStreamAgora').default)
Vue.component('user-video-header', require('./components/user/UserVideoHeader').default)

// ドラフト予約
Vue.component('user-draft-consultation-notifier', require('./components/user/consultations/UserDraftConsultationNotifier').default)
Vue.component('user-draft-consultation-confirm-modal', require('./components/user/modals/UserDraftConsultationConfirmModal').default)
Vue.component('user-draft-delete-modal', require('./components/user/modals/UserDraftDeleteModal').default)

// 相談画面の会員情報
Vue.component('user-info', require('./components/user/UserInfo').default)

// 相談画面のチャット
Vue.component('user-chat', require('./components/user/UserChat').default)

// 添付画像
Vue.component('user-consultation-attached-images', require('./components/user/UserConsultationAttachedImages').default)

// 問診回答一覧
Vue.component('user-interview-answers', require('./components/user/UserInterviewAnswers').default)

// 撮影画像
Vue.component('user-consultation-images', require('./components/user/UserConsultationImages').default)

// 相談記録エクスポートモーダル
Vue.component('user-export-medical-record-modal', require('./components/user/modals/UserExportMedicalRecordModal').default)

// 英語化問診票 - 相談科選択モーダル
Vue.component('user-interview-trans-question-medical-courses-modal', require('./components/user/modals/UserInterviewTransQuestionMedicalCoursesModal').default)

// 英語化問診票 - 回答モーダル
Vue.component('user-interview-trans-questions-modal', require('./components/user/modals/UserInterviewTransQuestionsModal').default)

// 英語化問診票 - 回答内容確認モーダル
Vue.component('user-interview-trans-questions-confirm-modal', require('./components/user/modals/UserInterviewTransQuestionsConfirmModal').default)

// 英語化問診票 - 翻訳内容確認モーダル
Vue.component('user-interview-trans-answers-modal', require('./components/user/modals/UserInterviewTransAnswersModal').default)

// 英語化問診票 - 翻訳内容修正モーダル
Vue.component('user-interview-trans-modification-modal', require('./components/user/modals/UserInterviewTransModificationModal').default)

// 英語化問診票 - 翻訳完了モーダル
Vue.component('user-interview-trans-completed-modal', require('./components/user/modals/UserInterviewTransCompletedModal').default)

// ダッシュボード
Vue.component('user-dashboard', require('./components/user/UserDashboard').default)

// 請求一覧（会員モード向け）
Vue.component('user-invoices', require('./components/user/UserInvoices').default)

// 相談一覧
Vue.component('user-consultations', require('./components/user/UserConsultations').default)

// 次回予約
Vue.component('user-consultation-next', require('./components/user/UserConsultationNext').default)

// 診療詳細モーダル
Vue.component('consultation-detail-modal', require('./components/user/modals/ConsultationDetailModal').default)

// 医師詳細モーダル
Vue.component('doctor-profile-modal', require('./components/user/modals/DoctorProfileModal').default)

// 医師メニュー選択モーダル
Vue.component('reservation-doctor-menus-modal', require('./components/user/modals/ReservationDoctorMenusModal').default)

// 医師メニュー詳細モーダル
Vue.component('reservation-doctor-menu-detail-modal', require('./components/user/modals/ReservationDoctorMenuDetailModal').default)

// 医師メニュー選択（予約時）
Vue.component('user-reservation-doctor-menu', require('./components/user/UserReservationDoctorMenu').default)

// 予約日時選択カレンダー
Vue.component('reservation-calendar', require('./components/user/ReservationCalendar').default)

// 日付から予約（希望日時から医師をマッチング）
Vue.component('user-reservation-matching-doctor-menu', require('./components/user/UserReservationMatchingDoctorMenu.vue').default)

// 問診入力モーダル
Vue.component('reservation-interview-modal', require('./components/user/modals/ReservationInterviewModal').default)

// 決済方法選択モーダル
Vue.component('reservation-payment-method-modal', require('./components/user/modals/ReservationPaymentMethodModal').default)

// 相談予約確認モーダル
Vue.component('reservation-confirm-modal', require('./components/user/modals/ReservationConfirmModal').default)

// プロフィール画面
Vue.component('profile-setting', require('./components/user/ProfileSetting').default)

// 相談予約キャンセルモーダル
Vue.component('reservation-cancel-modal', require('./components/user/modals/ReservationCancelModal').default)

// 会員ログイン
Vue.component('user-login', require('./components/user/UserLogin').default)

// 会員登録
Vue.component('user-signup', require('./components/user/UserSignup').default)

// 会員登録ステップ
Vue.component('user-signup-step', require('./components/user/UserSignupStep').default)

// 会員登録（団体利用アカウント発行）
Vue.component('user-signup-group', require('./components/user/UserSignupGroup').default)

// 会員仮登録完了（メールアドレス）
Vue.component('user-register-provisional-complete', require('./components/user/UserRegisterProvisionalComplete').default)

// 会員登録
Vue.component('user-register', require('./components/user/UserRegister').default)

// 会員登録完了
Vue.component('user-register-complete', require('./components/user/UserRegisterComplete').default)

// 利用規約同意
Vue.component('user-terms-agreement', require('./components/user/UserTermsAgreement').default)

// 定額プラン利用規約同意
Vue.component('user-terms-plan-agreement', require('./components/user/UserTermsPlanAgreement').default)

// formrun連携
Vue.component('formrun-association', require('./components/user/FormrunAssociation').default)

// 初回ログイン（国内版）
Vue.component('user-first-update', require('./components/user/UserFirstUpdate').default)

// 初回ログイン（海外版）
Vue.component('user-first-update-consul', require('./components/user/UserFirstUpdateConsul').default)

// アカウント管理
Vue.component('user-account', require('./components/user/UserAccount').default)

// アカウント管理（メールアドレス変更、パスワード変更）
Vue.component('user-account-primary', require('./components/user/UserAccountPrimary').default)

// アカウント管理（外部アカウント連携）
Vue.component('user-account-social', require('./components/user/UserAccountSocial').default)

// アカウント削除
Vue.component('user-leave', require('./components/user/UserLeave').default)

// プラン解約モーダル
Vue.component('subscription-cancel-modal', require('./components/user/modals/SubscriptionCancelModal').default)

// 書類アップロードモーダル
Vue.component('subscription-file-upload-modal', require('./components/user/modals/SubscriptionFileUploadModal').default)

// クーポン付与通知モーダル
Vue.component('user-coupons-notification-modal', require('./components/user/modals/UserCouponsNotificationModal').default)

// クーポンの使用方法モーダル
Vue.component('how-to-use-coupon-modal', require('./components/user/modals/HowToUseCouponModal').default)

// クーポンの使用条件モーダル
Vue.component('coupon-use-condition-modal', require('./components/user/modals/CouponUseConditionModal').default)

// サポートモーダル
Vue.component('user-support-modal', require('./components/user/modals/UserSupportModal').default)

// 所持クーポン一覧画面
Vue.component('user-user-coupons', require('./components/user/UserUserCoupons').default)

// クーポンコード入力フォーム
Vue.component('user-coupon-code-form', require('./components/user/UserCouponCodeForm').default)

// クーポンコード入力モーダル
Vue.component('user-coupon-code-modal', require('./components/user/modals/UserCouponCodeModal').default)

// メンタルチェック一覧画面
Vue.component('user-health-surveys', require('./components/user/UserHealthSurveys').default)

// メンタルチェック回答画面
Vue.component('user-health-survey-answer', require('./components/user/UserHealthSurveyAnswer').default)

// 【担当者画面】団体
Vue.component('authorizer-organization', require('./components/user/groups/AuthorizerOrganization').default)

// 【担当者画面】団体 > 所属法人詳細
Vue.component('authorizer-organization-company', require('./components/user/groups/AuthorizerOrganizationCompany').default)

// 【担当者画面】法人
Vue.component('authorizer-company', require('./components/user/groups/AuthorizerCompany').default)

// 【担当者画面】会員一覧（会員一覧タブ）
Vue.component('authorizer-group-users', require('./components/user/groups/AuthorizerGroupUsers').default)

// 【担当者画面】子グループ一覧（法人一覧タブ）
Vue.component('authorizer-child-groups', require('./components/user/groups/AuthorizerChildGroups').default)

// 【担当者画面】招待一覧（招待一覧タブ）
Vue.component('authorizer-group-invitations', require('./components/user/groups/AuthorizerGroupInvitations').default)

// 【担当者画面】相談一覧（相談一覧タブ）
Vue.component('authorizer-group-consultations', require('./components/user/groups/AuthorizerGroupConsultations').default)

// 【担当者画面】ドクターパス利用一覧（ドクターパス利用一覧タブ）
Vue.component('authorizer-group-subscriptions', require('./components/user/groups/AuthorizerGroupSubscriptions').default)

// 【担当者画面】管理用タグ一覧（管理用タグ一覧タブ）
Vue.component('authorizer-group-management-tags', require('./components/user/groups/AuthorizerGroupManagementTags').default)

// 【担当者画面】メンタルチェック回答一覧（メンタルチェック回答一覧タブ）
Vue.component('authorizer-group-health-surveys', require('./components/user/groups/AuthorizerGroupHealthSurveys').default)

// 【担当者画面】メンタルチェック回答履歴ダウンロードモーダル
Vue.component('authorizer-health-survey-download-modal', require('./components/user/modals/groups/AuthorizerHealthSurveyDownloadModal').default)

// 【担当者画面】グループ詳細
Vue.component('authorizer-group-info', require('./components/user/groups/AuthorizerGroupInfo').default)

// 【担当者画面】利用アカウント発行キャンセルモーダル
Vue.component('authorizer-group-invitation-cancel-modal', require('./components/user/modals/groups/AuthorizerGroupInvitationCancelModal').default)

// 【担当者画面】利用アカウント発行モーダル
Vue.component('authorizer-user-invite-modal', require('./components/user/modals/groups/AuthorizerUserInviteModal').default)

// 【担当者画面】会員編集モーダル
Vue.component('authorizer-group-user-edit-modal', require('./components/user/modals/groups/AuthorizerGroupUserEditModal').default)

// 【担当者画面】会員所属解除モーダル
Vue.component('authorizer-group-user-leave-modal', require('./components/user/modals/groups/AuthorizerGroupUserLeaveModal').default)

// 【担当者画面】子グループ追加モーダル
Vue.component('authorizer-child-group-add-modal', require('./components/user/modals/groups/AuthorizerChildGroupAddModal').default)

// 【担当者画面】子グループ編集モーダル
Vue.component('authorizer-child-group-edit-modal', require('./components/user/modals/groups/AuthorizerChildGroupEditModal').default)

// 【担当者画面】子グループ所属解除モーダル
Vue.component('authorizer-child-group-leave-modal', require('./components/user/modals/groups/AuthorizerChildGroupLeaveModal').default)

// 【担当者画面】子グループ所属会員追加モーダル
Vue.component('authorizer-child-group-users-store-modal', require('./components/user/modals/groups/AuthorizerChildGroupUsersStoreModal').default)

// 【担当者画面】法人管理用タグ追加モーダル
Vue.component('authorizer-group-management-tags-store-modal', require('./components/user/modals/groups/AuthorizerGroupManagementTagsStoreModal').default)

// 【担当者画面】法人管理用タグ編集モーダル
Vue.component('authorizer-group-management-tags-edit-modal', require('./components/user/modals/groups/AuthorizerGroupManagementTagsEditModal').default)

// 【担当者画面】法人管理用タグ削除モーダル
Vue.component('authorizer-group-management-tags-delete-modal', require('./components/user/modals/groups/AuthorizerGroupManagementTagsDeleteModal').default)

// 【担当者画面】会員管理用タグ追加モーダル
Vue.component('authorizer-user-management-tags-store-modal', require('./components/user/modals/groups/AuthorizerUserManagementTagsStoreModal').default)

// 【担当者画面】会員管理用タグ編集モーダル
Vue.component('authorizer-user-management-tags-edit-modal', require('./components/user/modals/groups/AuthorizerUserManagementTagsEditModal').default)

// 【担当者画面】会員管理用タグ削除モーダル
Vue.component('authorizer-user-management-tags-delete-modal', require('./components/user/modals/groups/AuthorizerUserManagementTagsDeleteModal').default)

/** ==========================================================================
 * 医師 関連コンポーネント
 * ========================================================================== */
// ナビゲーションバー
Vue.component('doctor-nav-bar', require('./components/doctor/NavBar').default)

// 診療一覧
Vue.component('doctor-consultations', require('./components/doctor/DoctorConsultations').default)

// 診療一覧モーダル
Vue.component('doctor-consultations-modal', require('./components/doctor/modals/DoctorConsultationsModal').default)

// 医師向け通知一覧
Vue.component('doctor-notifications', require('./components/doctor/DoctorNotifications').default)

// 医師メニュー一覧
Vue.component('doctor-doctor-menus', require('./components/doctor/DoctorDoctorMenus').default)

// 医師メニュー
Vue.component('doctor-doctor-menu', require('./components/doctor/DoctorDoctorMenu').default)

// // カレンダー
// Vue.component('doctor-dashboard-calendar', require('./components/doctor/DashboardCalendar').default)

// 診療画面: メイン
Vue.component('doctor-consultation', require('./components/doctor/DoctorConsultation').default)

// 診療画面: ビデオ
Vue.component('doctor-video-stream-agora', require('./components/doctor/DoctorVideoStreamAgora').default);

// 診療画面: 相談記録編集
Vue.component('medical-record-editor', require('./components/doctor/MedicalRecordEditor').default)

// 診療画面: 法人フィードバック編集
Vue.component('doctor-consultation-feedback-editor', require('./components/doctor/DoctorConsultationFeedbackEditor').default)

// 診療画面: チャット
Vue.component('doctor-chat', require('./components/doctor/DoctorChat').default)

// 撮影画像
Vue.component('doctor-consultation-images', require('./components/doctor/DoctorConsultationImages').default)

// 添付画像
Vue.component('doctor-consultation-attached-images', require('./components/doctor/DoctorConsultationAttachedImages').default)

// 診療記録一覧
Vue.component('doctor-medical-records', require('./components/doctor/DoctorMedicalRecords').default)

// 問診回答一覧
Vue.component('doctor-interview-answers', require('./components/doctor/DoctorInterviewAnswers').default)

// 診療スケジュール
Vue.component('doctor-schedules', require('./components/doctor/DoctorSchedules').default)

// 診療基本スケジュール
Vue.component('basic-schedule-table', require('./components/doctor/BasicScheduleTable').default)

// 診療例外スケジュール
Vue.component('exception-schedule-table', require('./components/doctor/ExceptionScheduleTable').default)

// 診療詳細モーダル
Vue.component('doctor-consultation-detail-modal', require('./components/doctor/modals/ConsultationDetailModal').default)

// 患者詳細モーダル
Vue.component('user-profile-modal', require('./components/doctor/modals/UserProfileModal').default)

// 新規診療予約: 患者検索モーダル
Vue.component('doctor-reservation-user-search-modal', require('./components/doctor/modals/DoctorReservationUserSearchModal').default)

// 新規診療予約: メニュー選択モーダル
Vue.component('doctor-reservation-doctor-menu-modal', require('./components/doctor/modals/DoctorReservationDoctorMenuModal').default)

// 新規診療予約: 日次選択モーダル
Vue.component('doctor-reservation-date-select-modal', require('./components/doctor/modals/DoctorReservationDateSelectModal').default)

// 新規診療予約: 決済方法選択モーダル
Vue.component('doctor-reservation-payment-method-modal', require('./components/doctor/modals/DoctorReservationPaymentMethodModal').default)

// 新規診療予約: 確認モーダル
Vue.component('doctor-reservation-confirm-modal', require('./components/doctor/modals/DoctorReservationConfirmModal').default)

// 問診内容
Vue.component('doctor-interview', require('./components/doctor/DoctorInterview').default)

// 各種設定 - 診療記録テンプレート
Vue.component('settings-medical-record-template', require('./components/doctor/SettingsMedicalRecordTemplate').default)

// 専属患者一覧
Vue.component('exclusive-users', require('./components/doctor/ExclusiveUsers').default)

// 専属患者追加モーダル
Vue.component('exclusive-user-add-modal', require('./components/doctor/modals/ExclusiveUserAddModal').default)
// 専属患者停止モーダル
Vue.component('exclusive-user-stop-modal', require('./components/doctor/modals/ExclusiveUserStopModal').default)
// 専属患者削除モーダル
Vue.component('exclusive-user-delete-modal', require('./components/doctor/modals/ExclusiveUserDeleteModal').default)
// 専属患者停止解除モーダル
Vue.component('exclusive-user-comeback-modal', require('./components/doctor/modals/ExclusiveUserComebackModal').default)
// 専属患者編集モーダル
Vue.component('exclusive-user-edit-modal', require('./components/doctor/modals/ExclusiveUserEditModal').default)

// Googleカレンダー連携LP
Vue.component('doctor-google-calendar-lp', require('./components/doctor/DoctorGoogleCalendarLp').default)
Vue.component('doctor-google-calendar-lp-privacy', require('./components/doctor/DoctorGoogleCalendarLpPrivacy').default)
Vue.component('doctor-google-calendar-lp-terms', require('./components/doctor/DoctorGoogleCalendarLpTerms').default)

// プロフィール画面
Vue.component('doctor-profile-setting', require('./components/doctor/ProfileSetting').default)

// 初回ログイン
Vue.component('doctor-first-update', require('./components/doctor/DoctorFirstUpdate').default)

// 利用制限
Vue.component('doctor-usage-restriction', require('./components/doctor/DoctorUsageRestriction').default)

// アカウント管理（メールアドレス変更、パスワード変更）
Vue.component('doctor-account', require('./components/doctor/DoctorAccount').default)

// 相談開始モーダル
Vue.component('doctor-reservation-start-modal', require('./components/doctor/modals/DoctorReservationStartModal').default)

// 相談キャンセルモーダル
Vue.component('doctor-reservation-cancel-modal', require('./components/doctor/modals/DoctorReservationCancelModal').default)

// 相談終了モーダル
Vue.component('doctor-reservation-finish-modal', require('./components/doctor/modals/DoctorReservationFinishModal').default)

// タイムゾーン変更確認モーダル
Vue.component('doctor-timezone-confirm-modal', require('./components/doctor/modals/DoctorTimezoneConfirmModal').default)

// サマータイム・冬時間跨ぎ確認モーダル
Vue.component('doctor-timezone-dst-confirm-modal', require('./components/doctor/modals/DoctorTimezoneDstConfirmModal').default)

// 医師カレンダーエクスポートモーダル
Vue.component('doctor-calendar-export-modal', require('./components/doctor/modals/DoctorCalendarExportModal').default)

// 医師Googleカレンダー連携モーダル
Vue.component('doctor-google-calendar-linkage-modal', require('./components/doctor/modals/DoctorGoogleCalendarLinkageModal').default)

// 医師連携アカウント選択モーダル
Vue.component('doctor-google-account-link-modal', require('./components/doctor/modals/DoctorGoogleAccountLinkModal').default)

// 医師連携アカウント選択モーダル
Vue.component('doctor-google-account-link-cancel-modal', require('./components/doctor/modals/DoctorGoogleAccountLinkCancelModal').default)

/** ==========================================================================
 * 管理画面 関連コンポーネント
 * ========================================================================== */
// 医師一覧
Vue.component('admin-doctors', require('./components/admin/AdminDoctors').default)
Vue.component('unrestrict-doctor-modal', require('./components/admin/modals/UnrestrictDoctorModal').default)
Vue.component('stop-doctor-modal', require('./components/admin/modals/StopDoctorModal').default)
Vue.component('comeback-doctor-modal', require('./components/admin/modals/ComebackDoctorModal').default)
Vue.component('delete-doctor-modal', require('./components/admin/modals/DeleteDoctorModal').default)
Vue.component('add-doctor-modal', require('./components/admin/modals/AddDoctorModal').default)
Vue.component('edit-doctor-modal', require('./components/admin/modals/EditDoctorModal').default)

// 医師設定
Vue.component('admin-doctor-settings', require('./components/admin/AdminDoctorSettings').default)

// 医師メニュー設定
Vue.component('admin-doctor-menus', require('./components/admin/AdminDoctorMenus').default)
Vue.component('admin-doctor-menu', require('./components/admin/AdminDoctorMenu').default)
Vue.component('admin-add-doctor-menu-modal', require('./components/admin/modals/AdminAddDoctorMenuModal').default)
Vue.component('admin-edit-doctor-menu-modal', require('./components/admin/modals/AdminEditDoctorMenuModal').default)
Vue.component('admin-toggle-status-doctor-menu-modal', require('./components/admin/modals/AdminToggleStatusDoctorMenuModal').default)
Vue.component('admin-delete-doctor-menu-modal', require('./components/admin/modals/AdminDeleteDoctorMenuModal').default)

// 会員一覧
Vue.component('admin-users', require('./components/admin/AdminUsers').default)
Vue.component('stop-user-modal', require('./components/admin/modals/StopUserModal').default)
Vue.component('comeback-user-modal', require('./components/admin/modals/ComebackUserModal').default)
Vue.component('delete-user-modal', require('./components/admin/modals/DeleteUserModal').default)
Vue.component('add-user-modal', require('./components/admin/modals/AddUserModal').default)
Vue.component('edit-user-modal', require('./components/admin/modals/EditUserModal').default)
Vue.component('admin-user-group-histories-modal', require('./components/admin/modals/AdminUserGroupHistoriesModal').default)
Vue.component('admin-user-subscription-histories-modal', require('./components/admin/modals/AdminUserSubscriptionHistoriesModal').default)

// 法人一覧
Vue.component('admin-companies', require('./components/admin/groups/AdminCompanies').default)
// 法人詳細
Vue.component('admin-company', require('./components/admin/groups/AdminCompany').default)

// 団体一覧
Vue.component('admin-organizations', require('./components/admin/groups/AdminOrganizations').default)
Vue.component('admin-group-user-histories-modal', require('./components/admin/modals/AdminGroupUserHistoriesModal').default)
// 団体詳細
Vue.component('admin-organization', require('./components/admin/groups/AdminOrganization').default)

// グループ詳細（会員一覧タブ）
Vue.component('admin-group-users', require('./components/admin/groups/AdminGroupUsers').default)
// グループ詳細（グループ一覧タブ）
Vue.component('admin-child-groups', require('./components/admin/groups/AdminChildGroups').default)
// グループ詳細（請求一覧タブ）
Vue.component('admin-group-invoices', require('./components/admin/groups/AdminGroupInvoices.vue').default)
// グループ詳細（相談一覧タブ）
Vue.component('admin-group-consultations', require('./components/admin/groups/AdminGroupConsultations').default)
// グループ詳細（ドクターパス利用一覧タブ）
Vue.component('admin-group-subscriptions', require('./components/admin/groups/AdminGroupSubscriptions').default)
// グループ詳細（招待一覧タブ）
Vue.component('admin-group-invitations', require('./components/admin/groups/AdminGroupInvitations').default)
// グループ詳細（利用アカウント発行URLタブ）
Vue.component('admin-group-form-url', require('./components/admin/groups/AdminGroupFormUrl').default)
// グループ詳細（メンタルチェック回答一覧タブ）
Vue.component('admin-group-health-surveys', require('./components/admin/groups/AdminGroupHealthSurveys').default)
// グループ詳細（ヘルスアンサー月次レポート一覧タブ）
Vue.component('admin-group-health-survey-reports', require('./components/admin/groups/AdminGroupHealthSurveyReports').default)

// ヘルスアンサー月次レポート詳細画面
Vue.component('admin-health-survey-report', require('./components/admin/AdminHealthSurveyReport').default)
// ヘルスアンサー月次レポート詳細画面（棒グラフ）
Vue.component('admin-health-survey-report-chart', require('./components/admin/AdminHealthSurveyReportChart').default)

// メンタルチェック一時停止モーダル
Vue.component('admin-health-survey-pause-modal', require('./components/admin/modals/AdminHealthSurveyPauseModal').default)
// メンタルチェック受付再開モーダル
Vue.component('admin-health-survey-resume-modal', require('./components/admin/modals/AdminHealthSurveyResumeModal').default)

// 質問デッキ追加モーダル
Vue.component('admin-add-health-survey-template-modal', require('./components/admin/modals/AdminAddHealthSurveyTemplateModal').default)
// 質問デッキ編集モーダル
Vue.component('admin-edit-health-survey-template-modal', require('./components/admin/modals/AdminEditHealthSurveyTemplateModal').default)
// 質問デッキ削除モーダル
Vue.component('admin-delete-health-survey-template-modal', require('./components/admin/modals/AdminDeleteHealthSurveyTemplateModal').default)

// 利用アカウント発行キャンセルモーダル
Vue.component('admin-group-invitation-cancel-modal', require('./components/admin/modals/groups/AdminGroupInvitationCancelModal').default)
// グループ所属会員追加モーダル
Vue.component('admin-group-users-store-modal', require('./components/admin/modals/groups/AdminGroupUsersStoreModal').default)
// グループ所属会員解除モーダル
Vue.component('admin-group-user-leave-modal', require('./components/admin/modals/groups/AdminGroupUserLeaveModal').default)

// グループ所属法人追加モーダル
Vue.component('admin-child-groups-store-modal', require('./components/admin/modals/groups/AdminChildGroupsStoreModal').default)
// グループ所属法人解除モーダル
Vue.component('admin-child-group-leave-modal', require('./components/admin/modals/groups/AdminChildGroupLeaveModal').default)

// グルーブ発行フォーム追加モーダル
Vue.component('admin-add-form-modal', require('./components/admin/modals/groups/AdminAddFormModal').default)
// グルーブ発行フォーム編集モーダル
Vue.component('admin-edit-form-modal', require('./components/admin/modals/groups/AdminEditFormModal').default)

// グループ追加モーダル
Vue.component('admin-add-group-modal', require('./components/admin/modals/groups/AdminAddGroupModal').default)
// グループ編集モーダル
Vue.component('admin-edit-group-modal', require('./components/admin/modals/groups/AdminEditGroupModal').default)
// グループ削除モーダル
Vue.component('admin-delete-group-modal', require('./components/admin/modals/groups/AdminDeleteGroupModal').default)
// グループ利用停止モーダル
Vue.component('admin-pause-group-modal', require('./components/admin/modals/groups/AdminPauseGroupModal').default)
// グループ利用再開モーダル
Vue.component('admin-resume-group-modal', require('./components/admin/modals/groups/AdminResumeGroupModal').default)

// ヘルスアンサー管理
Vue.component('admin-health-survey-templates', require('./components/admin/AdminHealthSurveyTemplates').default)
Vue.component('admin-health-survey-questions', require('./components/admin/AdminHealthSurveyQuestions').default)

// メンタルチェックスケジュール追加モーダル
Vue.component('admin-add-health-survey-group-detail-modal', require('./components/admin/modals/AdminAddHealthSurveyGroupDetailModal').default)
// メンタルチェックスケジュール編集モーダル
Vue.component('admin-edit-health-survey-group-detail-modal', require('./components/admin/modals/AdminEditHealthSurveyGroupDetailModal').default)

// 相談一覧
Vue.component('admin-consultations', require('./components/admin/AdminConsultations').default)
// 相談一覧:患者検索モーダル
Vue.component('admin-user-profile-modal', require('./components/admin/modals/AdminUserProfileModal').default)
// 相談一覧:相談記録一覧
Vue.component('admin-doctor-medical-records', require('./components/admin/AdminDoctorMedicalRecords').default)
// 代替メニュー選択モーダル
Vue.component('admin-alternative-doctor-menu-select-modal', require('./components/admin/modals/AdminAlternativeDoctorMenuSelectModal').default)
// 代替メニュースケジュールモーダル
Vue.component('admin-alternative-doctor-menu-schedule-modal', require('./components/admin/modals/AdminAlternativeDoctorMenuScheduleModal').default)
// 代替メニュー確認モーダル
Vue.component('admin-alternative-doctor-menu-confirm-modal', require('./components/admin/modals/AdminAlternativeDoctorMenuConfirmModal').default)
// マッチング医師選択モーダル
Vue.component('admin-matching-doctor-select-modal', require('./components/admin/modals/AdminMatchingDoctorSelectModal').default)
// マッチング医師確認モーダル
Vue.component('admin-matching-doctor-confirm-modal', require('./components/admin/modals/AdminMatchingDoctorConfirmModal').default)
// マッチング医師スケジュールモーダル
Vue.component('admin-matching-doctor-schedule-modal', require('./components/admin/modals/AdminMatchingDoctorScheduleModal').default)
// マッチング問診表示モーダル
Vue.component('admin-matching-interview-answers-modal', require('./components/admin/modals/AdminMatchingInterviewAnswersModal').default)

// 相談画面: メイン
Vue.component('admin-consultation', require('./components/admin/AdminConsultation').default)
// 相談画面: チャット
Vue.component('admin-chat', require('./components/admin/AdminChat').default)
// 相談画面: agora
Vue.component('admin-video-stream-agora', require('./components/admin/AdminVideoStreamAgora').default);

// 相談記録エクスポートモーダル
Vue.component('admin-export-medical-record-modal', require('./components/admin/modals/AdminExportMedicalRecordModal').default)

// 問診回答一覧
Vue.component('admin-doctor-interview-answers', require('./components/admin/AdminDoctorInterviewAnswers').default)
// 添付画像
Vue.component('admin-doctor-consultation-attached-images', require('./components/admin/AdminDoctorConsultationAttachedImages').default)
// 撮影画像
Vue.component('admin-doctor-consultation-images', require('./components/admin/AdminDoctorConsultationImages').default)

// 医師詳細モーダル
Vue.component('admin-doctor-profile-modal', require('./components/admin/modals/AdminDoctorProfileModal').default)

// 英語化問診票一覧
Vue.component('admin-interview-trans-profiles', require('./components/admin/AdminInterviewTransProfiles').default)

// クーポンマスタ一覧
Vue.component('admin-coupons', require('./components/admin/AdminCoupons').default)
Vue.component('admin-add-coupon-modal', require('./components/admin/modals/AdminAddCouponModal').default)
Vue.component('admin-edit-coupon-modal', require('./components/admin/modals/AdminEditCouponModal').default)
Vue.component('admin-delete-coupon-modal', require('./components/admin/modals/AdminDeleteCouponModal').default)

// クーポンコード一覧
Vue.component('admin-coupon-codes', require('./components/admin/AdminCouponCodes').default)
Vue.component('admin-edit-coupon-code-modal', require('./components/admin/modals/AdminEditCouponCodeModal').default)
Vue.component('admin-delete-coupon-code-modal', require('./components/admin/modals/AdminDeleteCouponCodeModal').default)

// クーポン情報
Vue.component('admin-coupons-info', require('./components/admin/AdminCouponsInfo').default)

// 発行クーポン一覧
Vue.component('admin-user-coupons', require('./components/admin/AdminUserCoupons').default)

// プラン一覧
Vue.component('admin-plans', require('./components/admin/AdminPlans').default)

// プラン追加モーダル
Vue.component('admin-add-plan-modal', require('./components/admin/modals/AdminAddPlanModal').default)

// プラン編集モーダル
Vue.component('admin-edit-plan-modal', require('./components/admin/modals/AdminEditPlanModal').default)

// プラン削除モーダル
Vue.component('admin-delete-plan-modal', require('./components/admin/modals/AdminDeletePlanModal').default)

// サービスモデル設定モーダル
Vue.component('admin-service-model-setting-modal', require('./components/admin/modals/AdminServiceModelSettingModal').default)

// プラン申込一覧
Vue.component('admin-subscription-reviews', require('./components/admin/AdminSubscriptionReviews').default)

// スケジュール管理
Vue.component('admin-doctor-schedules', require('./components/admin/AdminDoctorSchedules').default)

// 相談科一覧
Vue.component('admin-medical-courses', require('./components/admin/AdminMedicalCourses').default)

// 相談科問診一覧
Vue.component('admin-medical-courses-questions', require('./components/admin/AdminMedicalCoursesQuestions').default)

// マッチング問診一覧
Vue.component('admin-interview-matching-questions', require('./components/admin/AdminInterviewMatchingQuestions').default)

// 翻訳問診一覧
Vue.component('admin-interview-trans-questions', require('./components/admin/AdminInterviewTransQuestions').default)

// 監査ログ一覧
Vue.component('admin-audits', require('./components/admin/AdminAudits').default)

// 設定
Vue.component('admin-configurations', require('./components/admin/AdminConfigurations').default)
Vue.component('admin-conf-basic', require('./components/admin/configurations/AdminConfBasic').default)
Vue.component('admin-conf-consultation', require('./components/admin/configurations/AdminConfConsultation').default)
Vue.component('admin-conf-user-code', require('./components/admin/configurations/AdminConfUserCode').default)
Vue.component('admin-conf-cancel-policy', require('./components/admin/configurations/AdminConfCancelPolicy').default)
Vue.component('admin-conf-law', require('./components/admin/configurations/AdminConfLaw').default)
Vue.component('admin-conf-mail', require('./components/admin/configurations/AdminConfMail').default)
Vue.component('admin-conf-mail-edit', require('./components/admin/configurations/AdminConfMailEdit').default)
Vue.component('admin-conf-timezone', require('./components/admin/configurations/AdminConfTimezone').default)
Vue.component('admin-conf-payment', require('./components/admin/configurations/AdminConfPayment').default)
Vue.component('admin-conf-invoice', require('./components/admin/configurations/AdminConfInvoice').default)
Vue.component('admin-conf-subscription', require('./components/admin/configurations/AdminConfSubscription').default)
Vue.component('admin-conf-admin', require('./components/admin/configurations/AdminConfAdmin').default)
Vue.component('admin-conf-maintenance', require('./components/admin/configurations/AdminConfMaintenance').default)

Vue.component('admin-add-medical-course-modal', require('./components/admin/modals/AdminAddMedicalCourseModal').default)
Vue.component('admin-edit-medical-course-modal', require('./components/admin/modals/AdminEditMedicalCourseModal').default)
Vue.component('admin-delete-medical-course-modal', require('./components/admin/modals/AdminDeleteMedicalCourseModal').default)
Vue.component('cannot-delete-medical-course-modal', require('./components/admin/modals/CannotDeleteMedicalCourseModal').default)

Vue.component('admin-conf-user-categories', require('./components/admin/configurations/AdminConfUserCategories').default)
Vue.component('add-user-category-modal', require('./components/admin/modals/AddUserCategoryModal').default)
Vue.component('delete-user-category-modal', require('./components/admin/modals/DeleteUserCategoryModal').default)
Vue.component('cannot-delete-user-category-modal', require('./components/admin/modals/CannotDeleteUserCategoryModal').default)

// 初回ログイン
Vue.component('admin-first-update', require('./components/admin/AdminFirstUpdate').default)

// アカウント管理（パスワード変更）
Vue.component('admin-account', require('./components/admin/AdminAccount').default)

/** ==========================================================================
 * 共通コンポーネント
 * ========================================================================== */
// 設定ステートマッピング
Vue.component('config-state', require('./components/common/vuex/ConfigState').default)

// 他ユーザモードのstateクリア
Vue.component('clear-other-state', require('./components/common/vuex/ClearOtherState').default)

// アラート
Vue.component('alert', require('./components/common/Alert').default)

// 特定のケースで使用されるアラート
Vue.component('case-alert', require('./components/common/CaseAlert').default)

// 診療時間グローバルアラート
Vue.component('consultation-global-alert', require('./components/common/ConsultationGlobalAlert').default)

// 共通コンテンツ（医師メニュー）
Vue.component('doctor-menu-info', require('./components/common/DoctorMenuInfo').default)

// 共通コンテンツ（医師メニュー基本情報）
Vue.component('doctor-menu-base-info', require('./components/common/DoctorMenuBaseInfo').default)

// 共通コンテンツ（医師情報）
Vue.component('doctor-info', require('./components/common/DoctorInfo').default)

// チャット
Vue.component('chat', require('./components/common/Chat').default)
Vue.component('chat-block', require('./components/common/ChatBlock').default)

// 相談画面: 相談記録ビューワ
Vue.component('medical-record-viewer', require('./components/common/MedicalRecordViewer').default)

// 相談画面: 法人フィードバックビューワ
Vue.component('consultation-feedback-viewer', require('./components/common/ConsultationFeedbackViewer').default)

// タイマー
Vue.component('consultation-timer', require('./components/common/ConsultationTimer').default)

// 相談終了N分前タイマー
Vue.component('alert-consultation-timer', require('./components/common/AlertConsultationTimer').default)

// 相談予約の残時間表示
Vue.component('reservation-rest-time', require('./components/common/ReservationRestTime').default)

// 患者プロフィール
Vue.component('user-profile', require('./components/user/UserProfile').default)

// 医師プロフィール
Vue.component('doctor-profile', require('./components/doctor/DoctorProfile').default)

// プロフィール画像アップロード
Vue.component('upload-profile-image', require('./components/common/UploadProfileImage').default)

// 新規診療予約ボタン
Vue.component('btn-new-reservation', require('./components/common/BtnNewReservation').default)

// 画像拡大表示モーダル
Vue.component('image-modal', require('./components/common/ImageModal').default)

// ファイル削除モーダル
Vue.component('delete-file-modal', require('./components/common/modals/DeleteFileModal').default)

// デバイスのタイムゾーン同期
Vue.component('timezone-device-sync', require('./components/common/TimezoneDeviceSync').default)

// ヘッダー用タイムゾーン表示
Vue.component('timezone', require('./components/common/Timezone').default)

// タイムゾーン併記
Vue.component('timezone-box', require('./components/common/TimezoneBox').default)

// タイムゾーン併記（JST固定）
Vue.component('timezone-box-jst', require('./components/common/TimezoneBoxJst').default)

// タイムゾーン併記（汎用）
Vue.component('timezone-box-common', require('./components/common/TimezoneBoxCommon').default)

// クレジットカード一覧
Vue.component('credit-cards', require('./components/common/CreditCards').default)

// クレジットカード登録モーダル
Vue.component('store-credit-card-modal', require('./components/common/modals/StoreCreditCardModal').default)

// クレジットカード削除モーダル
Vue.component('destroy-credit-card-modal', require('./components/common/modals/DestroyCreditCardModal').default)

// クレジットカード登録フォーム
Vue.component('store-credit-card-form', require('./components/common/StoreCreditCardForm').default)

// 請求書作成モーダル（手動請求用）
Vue.component('manual-store-invoice-modal', require('./components/common/modals/ManualStoreInvoiceModal').default)

// 請求書作成確認モーダル（手動請求用）
Vue.component('manual-confirm-invoice-modal', require('./components/common/modals/ManualConfirmInvoiceModal').default)

// 確定済請求書の請求モーダル
Vue.component('auth-confirm-invoice-modal', require('./components/common/modals/AuthConfirmInvoiceModal').default)

// 請求書キャンセルモーダル
Vue.component('cancel-invoice-modal', require('./components/admin/modals/CancelInvoiceModal').default)

// 支払い再試行モーダル
Vue.component('retry-payment-modal', require('./components/common/modals/RetryPaymentModal').default)

// 請求一覧（医師・管理者モード向け）
Vue.component('invoices', require('./components/common/Invoices').default)

// 定期課金セットアップ
Vue.component('subscriptions-setup', require('./components/user/SubscriptionsSetup').default)

// プラン情報
Vue.component('plan-info', require('./components/common/PlanInfo').default)

// クーポン情報
Vue.component('coupons-info', require('./components/common/CouponsInfo').default)

// ページ移動モーダル
Vue.component('page-transition-modal', require('./components/common/modals/PageTransitionModal').default)

// 医師メニューモーダル
Vue.component('doctor-menu-modal', require('./components/common/modals/DoctorMenuModal').default)

// 問診設定
Vue.component('settings-interview-question', require('./components/common/SettingsInterviewQuestion').default)

// マイクとカメラのテストモーダル
Vue.component('video-test-modal', require('./components/common/modals/VideoTestModal').default)

// ネットワーク接続のテストモーダル
Vue.component('network-test-modal', require('./components/common/modals/NetworkTestModal').default)

// 相談キャンセル情報モーダル
Vue.component('consultation-cancel-info-modal', require('./components/common/modals/ConsultationCancelInfoModal').default)

/** ==========================================================================
 * 共通コンポーネント（フォーム要素）
 * ========================================================================== */
Vue.component('toggle', require('./components/forms/Toggle').default)
Vue.component('removable-text-input', require('./components/forms/RemovableTextInput').default)


/** ==========================================================================
 * WebSocket通知
 * ========================================================================== */
// window.Pusher.logToConsole = true


/** ==========================================================================
 * 設定関連
 * ========================================================================== */
Vue.filter('formatSize', function (size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
    }
    return size.toString() + ' B'
})
